// extracted by mini-css-extract-plugin
export default {"nav":"styles_nav__w38de","item":"styles_item__pF-E6","menu":"styles_menu__Iicna"};